import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';

const SegmentSummaryTable = ({
  rowHeader,
  rowData,
  handleContentScroll,
 }) => {
  return (
    <div
      className="generic-bt-content-row"
      data-test="segment-summary-table"
    >
      <Fragment>
        <div className="generic-bt-content-row-left" id="left-menu-content">
          {rowHeader && rowHeader.map(row => (<div
            key={uuid()}
            title={row}
            className="generic-bt-content-row-left-item"
          >{row}
          </div>))}
        </div>
        <div id="main-content-grid" className="generic-bt-content-row-right" onScroll={e => handleContentScroll(e)}>
          {rowData && rowData.map(row => (<div key={uuid()} className="generic-bt-content-row-right-item">
            {row.values.map(item => (
              <div
                key={uuid()}
                title={item}
                className="generic-bt-content-row-right-item-value"
              >{item}
              </div>
              ))}
          </div>))}
        </div>
      </Fragment>
    </div>
  );
};

SegmentSummaryTable.propTypes = {
  rowData: PropTypes.arrayOf(PropTypes.object),
  rowHeader: PropTypes.arrayOf(PropTypes.string),
  handleContentScroll: PropTypes.func,
};

export default SegmentSummaryTable;
